<template>
    <div class="app-layout">
        <header>
            <slot name="app-header"/>
        </header>
        <main>
            <section>
                <slot/>
            </section>
            <footer>
                <slot name="app-footer"/>
            </footer>
        </main>
    </div>
</template>

<script>
    import { isSafari } from "../../util/browser"
    export default {
        name: "AppLayout",
        computed: {
            safari() { return isSafari }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/styles/breakpoints.scss";
    .app-layout {
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        height: 100vh;
        main {
            display: flex;
            display: -webkit-flex;
            flex-direction: column;
            flex: 1;
            -webkit-flex: 1;
            overflow-y: auto;
            section {
                flex: 1 1 auto;
                @include onlyIE() { flex-shrink: 0; }
            }
        }
    }
</style>
